module.exports = __webpack_public_path__ + "static/media/default_image_ltlabs_logo.4ac7d3d0.svg";